import { MouseEvent, useCallback, useMemo, useState } from 'react';

export interface OptionSwitchOption<OptionId> {
  value: OptionId;
  label: string;
  icon: string;
}

export const useOptionSwitch = <OptionId>(
  optionsMap: Map<OptionId, OptionSwitchOption<OptionId>>,
  currentValue: OptionId,
) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const openSwitch = useCallback(
    (event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget),
    [],
  );

  const closeSwitch = useCallback(() => setAnchorEl(null), []);

  const selectedOption = useMemo(
    () => optionsMap.get(currentValue),
    [optionsMap, currentValue],
  );

  return { anchorEl, openSwitch, closeSwitch, selectedOption };
};
